


























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class Shipment extends Vue {
  @Prop({})
  shipments: any[];

  selectedShipment = "";

  select(shipment: any) {
    this.selectedShipment = shipment;
    this.$emit("selectevent", shipment);
  }
}
